const TODAY = new Date().toISOString().slice(0, 10);

const STAGE_LABEL = {
  new:         "New",
  qualified:   "Qualified",
  demoFn:      "Demo FN",
  demoTech:    "Demo Tech",
  negotiation: "Negotiation",
  won:         "Won",
  lost:        "Lost",
};

function fmtINR(paise) {
  if (!paise) return "—";
  const n = paise / 100;
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)}Cr`;
  if (n >= 100000)   return `₹${(n / 100000).toFixed(1)}L`;
  if (n >= 1000)     return `₹${(n / 1000).toFixed(0)}k`;
  return `₹${n.toLocaleString("en-IN")}`;
}

function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.getDate().toString().padStart(2, "0")} ${d.toLocaleString("en", { month: "short" })}`;
}

function relDate(iso) {
  if (!iso) return "";
  const diff = Math.round((new Date(iso) - new Date(TODAY)) / 86400000);
  if (diff === 0)  return "today";
  if (diff === 1)  return "tomorrow";
  if (diff === -1) return "yesterday";
  if (diff > 0)   return `in ${diff}d`;
  return `${Math.abs(diff)}d overdue`;
}

function nextClass(iso) {
  if (!iso) return "";
  const diff = Math.round((new Date(iso) - new Date(TODAY)) / 86400000);
  if (diff < 0) return "overdue";
  if (diff <= 2) return "due-soon";
  return "";
}

function ageClass(days) {
  if (!days && days !== 0) return "";
  if (days > 14) return "bad";
  if (days >= 7) return "warn";
  return "ok";
}

function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2);
}

function companyInfo(lead) {
  const parts = [lead?.location, lead?.company_type].filter(Boolean);
  return parts.join(" · ");
}

export default function PresalesTable({ leads, selectedId, onSelect }) {
  if (leads.length === 0) {
    return (
      <div className="page-table-wrap">
        <div className="ps-empty">No leads found</div>
      </div>
    );
  }

  return (
    <div className="page-table-wrap">
      <table className="page-table">
        <colgroup>
          <col style={{ width: 180 }} />
          <col style={{ width: 200 }} />
          <col style={{ width: 120 }} />
          <col style={{ width: 130 }} />
          <col style={{ width: 80 }} />
          <col style={{ width: 200 }} />
          <col style={{ width: 110 }} />
          <col style={{ width: 150 }} />
        </colgroup>
        <thead>
          <tr>
            <th>Company</th>
            <th>Lead</th>
            <th>Product</th>
            <th>Stage</th>
            <th>Age</th>
            <th>Next Action</th>
            <th className="num">Value</th>
            <th>Owner</th>
          </tr>
        </thead>
        <tbody>
          {leads.map((l) => {
            const isClosed = l.stage === "won" || l.stage === "lost";
            const ac = ageClass(l.days_in_stage);
            const nc = nextClass(l.next_action_date);
            const isActive = l.id === selectedId;

            return (
              <tr
                key={l.id}
                className={isActive ? "ps-row-active" : ""}
                onClick={() => onSelect(l.id)}
              >
                <td className="ps-sticky">
                  <div className="ps-lead-co">
                    <span className="c1">{l.company_name}</span>
                    {companyInfo(l) && <span className="c2">{companyInfo(l)}</span>}
                  </div>
                </td>
                <td>
                  <div className="ps-lead-name">
                    <span className="n1">{l.contact_name}</span>
                    <span className="n2">
                      {l.lead_number}
                      {l.designation ? ` · ${l.designation}` : ""}
                    </span>
                  </div>
                </td>
                <td>
                  {l.product_name ? (
                    <span className="ps-prod-tag" data-p={l.product_slug}>
                      {l.product_name}
                    </span>
                  ) : (
                    <span className="ps-prod-tag empty">—</span>
                  )}
                </td>
                <td>
                  <span className={`ps-stage-pill ${l.stage}`}>
                    <span className="sw" />
                    {STAGE_LABEL[l.stage] || l.stage}
                  </span>
                </td>
                <td>
                  {isClosed ? (
                    <span className="ps-age">—</span>
                  ) : (
                    <span className={`ps-age ${ac}`}>
                      <span className="dot" />
                      {l.days_in_stage != null ? `${l.days_in_stage}d` : "—"}
                    </span>
                  )}
                </td>
                <td>
                  <div className={`ps-next ${nc}`}>
                    <span className="n1">{l.next_action || "—"}</span>
                    {l.next_action_date && (
                      <span className="n2">
                        {fmtDate(l.next_action_date)} · {relDate(l.next_action_date)}
                      </span>
                    )}
                  </div>
                </td>
                <td className="num">
                  <span className="ps-value">{fmtINR(l.deal_value)}</span>
                </td>
                <td>
                  <span className="ps-owner-cell">
                    <span className="ps-owner-av">{initials(l.owner_name)}</span>
                    <span className="ps-owner-nm">{l.owner_name || "—"}</span>
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
